/**
 * A simple in-memory cache utility for storing and retrieving data.
 */
export default class Cache {
  static KEYS = Object.freeze({
    loadCampaignSchedules: 'loadCampaignSchedules',
    loadUsers: 'loadUsers',
    loadCurrentUser: 'loadCurrentUser',
    loadPlaylist: 'loadPlaylist',
    loadAssets: 'loadAssets',
    loadAllSequences: 'loadAllSequences',
    loadSequence: 'loadSequence',
    loadSign: 'loadSign',
    loadAssignments: 'loadAssignments',
  });

  static #CACHE = {};

  /**
   * Gets a cache record for the given key.
   * @param {string} key - The cache key.
   * @param {string} subkey - The cache subkey.
   * @returns {any} The cached value or undefined if not found.
   */
  static getCache = (key, subkey) => Cache.#CACHE[key]?.[subkey];

  /**
   * Sets a cache record for the given key and value.
   * @param {string} key - The cache key.
   * @param {string} subkey - The cache subkey.
   * @param {any} value - The value to cache.
   * @returns {any} The cached value.
   */
  static setCache = (key, subkey, value) => {
    if (!Cache.#CACHE[key]) {
      Cache.#CACHE[key] = {};
    }

    Cache.#CACHE[key][subkey] = value;

    return value;
  };

  /**
   * Clears the entire cache.
   * Use with caution as this will remove all cached data.
   */
  static clearCache = () => {
    Cache.#CACHE = {};
  };
}
